import { z } from 'zod';
import { UuidSchema } from './common.js';

/**
 * Gespeicherte Reihenfolge des Übergabe-Eingangs (#115), als reine Liste von Projekt-IDs in
 * ihrer Anzeigefolge. Position wird nicht mitgeschickt — sie ergibt sich aus dem Index im Array.
 */
export const UebergabeReihenfolgeSchema = z.object({
  items: z.array(UuidSchema),
});
export type UebergabeReihenfolge = z.infer<typeof UebergabeReihenfolgeSchema>;

/**
 * Input zum Verschieben eines Projekts innerhalb der Reihenfolge (#115). `before_project_id`
 * ist das Projekt, VOR das `project_id` gesetzt werden soll; `null` heißt ans Ende.
 */
export const VerschiebeReihenfolgeSchema = z.object({
  project_id: UuidSchema,
  before_project_id: UuidSchema.nullable(),
});
export type VerschiebeReihenfolge = z.infer<typeof VerschiebeReihenfolgeSchema>;
